 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"cpe-home":"cpe-home","cpe-layout":"cpe-layout","customer-dashboard":"customer-dashboard","dg-suite":"dg-suite","dg-suite-cookie-manager":"dg-suite-cookie-manager","dg-suite-cookie-manager-access":"dg-suite-cookie-manager-access","dg-suite-cookie-manager-config":"dg-suite-cookie-manager-config","dg-suite-cookie-manager-integration":"dg-suite-cookie-manager-integration","dg-suite-preference-mgmt":"dg-suite-preference-mgmt","dg-suite-product-details":"dg-suite-product-details","dg-suite-whistle-blowing":"dg-suite-whistle-blowing","documentation-dashboard":"documentation-dashboard","dsr-create~todos":"dsr-create~todos","dsr-create":"dsr-create","todos":"todos","dsr-dashboard":"dsr-dashboard","dsr-details":"dsr-details","dsr-settings":"dsr-settings","lang-de-json":"lang-de-json","lang-en-json":"lang-en-json","login-component":"login-component","logout-component":"logout-component","mcp":"mcp","mcp-details":"mcp-details","news":"news","no-access-component":"no-access-component","ppm-create~ppm-details~ppm-review~ppm-upload":"ppm-create~ppm-details~ppm-review~ppm-upload","ppm-create":"ppm-create","ppm-details":"ppm-details","ppm-review":"ppm-review","ppm-upload":"ppm-upload","ppm-dashboard":"ppm-dashboard","ppm-info-section":"ppm-info-section","profile":"profile","under-maintenance":"under-maintenance"}[chunkId]||chunkId) + "." + {"cpe-home":"061080d0","cpe-layout":"43182311","customer-dashboard":"0dfbe90b","dg-suite":"f80c8921","dg-suite-cookie-manager":"6035eee3","dg-suite-cookie-manager-access":"b2bfc3a5","dg-suite-cookie-manager-config":"b13f4a8f","dg-suite-cookie-manager-integration":"4490e0ee","dg-suite-preference-mgmt":"69376980","dg-suite-product-details":"70508541","dg-suite-whistle-blowing":"b61cbc78","documentation-dashboard":"34f39c28","dsr-create~todos":"4d573bf1","dsr-create":"59bac121","todos":"efb1e0ec","dsr-dashboard":"dee03526","dsr-details":"de7e322e","dsr-settings":"56dd4044","lang-de-json":"e16cbf99","lang-en-json":"6349783a","login-component":"1127d355","logout-component":"1663a11d","mcp":"de3dd64b","mcp-details":"a4011a1f","news":"802082e3","no-access-component":"4d0ef84d","ppm-create~ppm-details~ppm-review~ppm-upload":"76df11bc","ppm-create":"a5c568eb","ppm-details":"458cd838","ppm-review":"2d3f876f","ppm-upload":"5973e25d","ppm-dashboard":"c8d0cb6f","ppm-info-section":"4e91a0f8","profile":"2c5a1c71","under-maintenance":"95b14f50","chunk-b9fad558":"a576c84b","chunk-2250d86a":"ce5ebfda","chunk-664a3b40":"4421b3ee","chunk-c28cfabe":"ea9bb2a1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"cpe-home":1,"cpe-layout":1,"customer-dashboard":1,"dg-suite":1,"dg-suite-cookie-manager":1,"dg-suite-cookie-manager-access":1,"dg-suite-cookie-manager-config":1,"dg-suite-cookie-manager-integration":1,"dg-suite-product-details":1,"documentation-dashboard":1,"dsr-create":1,"todos":1,"dsr-dashboard":1,"dsr-details":1,"dsr-settings":1,"login-component":1,"logout-component":1,"mcp":1,"mcp-details":1,"news":1,"no-access-component":1,"ppm-create~ppm-details~ppm-review~ppm-upload":1,"ppm-details":1,"ppm-dashboard":1,"ppm-info-section":1,"profile":1,"under-maintenance":1,"chunk-b9fad558":1,"chunk-2250d86a":1,"chunk-664a3b40":1,"chunk-c28cfabe":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"cpe-home":"cpe-home","cpe-layout":"cpe-layout","customer-dashboard":"customer-dashboard","dg-suite":"dg-suite","dg-suite-cookie-manager":"dg-suite-cookie-manager","dg-suite-cookie-manager-access":"dg-suite-cookie-manager-access","dg-suite-cookie-manager-config":"dg-suite-cookie-manager-config","dg-suite-cookie-manager-integration":"dg-suite-cookie-manager-integration","dg-suite-preference-mgmt":"dg-suite-preference-mgmt","dg-suite-product-details":"dg-suite-product-details","dg-suite-whistle-blowing":"dg-suite-whistle-blowing","documentation-dashboard":"documentation-dashboard","dsr-create~todos":"dsr-create~todos","dsr-create":"dsr-create","todos":"todos","dsr-dashboard":"dsr-dashboard","dsr-details":"dsr-details","dsr-settings":"dsr-settings","lang-de-json":"lang-de-json","lang-en-json":"lang-en-json","login-component":"login-component","logout-component":"logout-component","mcp":"mcp","mcp-details":"mcp-details","news":"news","no-access-component":"no-access-component","ppm-create~ppm-details~ppm-review~ppm-upload":"ppm-create~ppm-details~ppm-review~ppm-upload","ppm-create":"ppm-create","ppm-details":"ppm-details","ppm-review":"ppm-review","ppm-upload":"ppm-upload","ppm-dashboard":"ppm-dashboard","ppm-info-section":"ppm-info-section","profile":"profile","under-maintenance":"under-maintenance"}[chunkId]||chunkId) + "." + {"cpe-home":"21366c47","cpe-layout":"682ab9ae","customer-dashboard":"6eb70a2f","dg-suite":"37ea14c2","dg-suite-cookie-manager":"01aed612","dg-suite-cookie-manager-access":"bd67c823","dg-suite-cookie-manager-config":"39e333eb","dg-suite-cookie-manager-integration":"8ab18c93","dg-suite-preference-mgmt":"31d6cfe0","dg-suite-product-details":"34f6274f","dg-suite-whistle-blowing":"31d6cfe0","documentation-dashboard":"f747999d","dsr-create~todos":"31d6cfe0","dsr-create":"3d2ca37a","todos":"2454b28d","dsr-dashboard":"5680cde8","dsr-details":"dace2b3d","dsr-settings":"79ee1ffa","lang-de-json":"31d6cfe0","lang-en-json":"31d6cfe0","login-component":"bff24907","logout-component":"219b69b4","mcp":"36cd443f","mcp-details":"5f60c28e","news":"e626f3dd","no-access-component":"dacc14ba","ppm-create~ppm-details~ppm-review~ppm-upload":"89c22189","ppm-create":"31d6cfe0","ppm-details":"614f7913","ppm-review":"31d6cfe0","ppm-upload":"31d6cfe0","ppm-dashboard":"22edb7da","ppm-info-section":"ba93e695","profile":"b6bd2566","under-maintenance":"d7045e30","chunk-b9fad558":"f69cf441","chunk-2250d86a":"9409770a","chunk-664a3b40":"8720eb7a","chunk-c28cfabe":"5a84b002"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
